<template>
  <div>
    <div :class="fieldClass">
      <input
        :type="field.type"
        :class="inputClass"
        :placeholder="field.placeholder"
        :name="field.name"
        :id="`${field.name}-field`"
        :required="isRequired"
        v-validate="field.validation"
        autocomplete="nope"
      >
      <span class="icon is-small is-left has-text-grey" v-if="field.icon">
        <fa :icon="field.icon"></fa>
      </span>
      <span
        class="icon is-small is-right has-text-danger"
        v-if="field.validation.required && !errors.has(field.name) && !notEmptyNotInvalid"
      >
        <fa icon="asterisk" class="fa-xs"></fa>
      </span>
      <span
        class="icon is-small is-right has-text-danger"
        v-if="errors.has(field.name)"
      >
        <fa icon="exclamation-triangle"></fa>
      </span>
      <span
        class="icon is-small is-right has-text-success"
        v-if="notEmptyNotInvalid"
      >
        <fa icon="check"></fa>
      </span>
    </div>
    <p class="help is-danger" v-if="errors.has(field.name)">
      {{ errors.first(field.name) }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
  computed: {
    fieldValidator() {
      return this.$validator.fields.find({ name: this.field.name });
    },
    notEmptyNotInvalid() {
      if (this.fieldValidator) {
        return !this.errors.has(this.field.name) && this.fieldValidator.value;
      }
      return false;
    },
    inputClass() {
      if (this.fieldValidator) {
        return {
          textarea: true,
          'is-danger': this.errors.has(this.field.name),
          'is-success': this.notEmptyNotInvalid,
        };
      }
      return {
        input: true,
      };
    },
    fieldClass() {
      return {
        control: true,
        'has-icons-right': true,
        'has-icons-left': this.field.icon,
      };
    },
    isRequired() {
      if (this.fieldValidator) {
        return this.field.validation.required;
      }
      return false;
    },
  },
};
</script>
